import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyAccommodations = loadable(() => import(/* webpackChunkName: "content/guestSiteAccommodations" */ './Accommodations'), 'Accommodations');
